export enum ChartExportButton {
  PrintChart = 'printChart',
  Separator = 'separator',
  DownloadPNG = 'downloadPNG',
  DownloadJPEG = 'downloadJPEG',
  DownloadPDF = 'downloadPDF',
  DownloadSVG = 'downloadSVG',
}
